import { TApplication } from '@dto';
import { ModuleDefault } from '@modules/default';

export class Update extends ModuleDefault {
  public update<T> (application: TApplication, body: T): Promise<void> {
    return this.request.patch(`${this.setup.urlBase}/onboarding/${application}`, body);
  }
}
